import { useEffect, useState, useRef } from 'react';
import { supabase } from '../supabaseClient';

/**
 * 監聽 system_updates 表的 Realtime 變更
 * 當對應 system_key 的 updated_at 被更新時，顯示更新通知
 *
 * @param {string} systemKey - 'main' | 'project' | 'kms' | 'business' | 'datasheet'
 */
export default function useSystemUpdate(systemKey) {
  const [updateInfo, setUpdateInfo] = useState(null); // { message, updated_at }
  const initialLoadedRef = useRef(false);
  const lastUpdatedAtRef = useRef(null);

  useEffect(() => {
    if (!systemKey) return;

    // 先取得目前的 updated_at 作為基準（不顯示通知）
    supabase
      .from('system_updates')
      .select('updated_at')
      .eq('system_key', systemKey)
      .single()
      .then(({ data }) => {
        if (data) {
          lastUpdatedAtRef.current = data.updated_at;
          initialLoadedRef.current = true;
        }
      });

    // Subscribe realtime changes
    const channel = supabase
      .channel(`system-update-${systemKey}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'system_updates',
          filter: `system_key=eq.${systemKey}`,
        },
        (payload) => {
          const { updated_at, message } = payload.new;

          // 忽略初始載入前的事件
          if (!initialLoadedRef.current) return;

          // 忽略跟上次一樣的 timestamp
          if (updated_at === lastUpdatedAtRef.current) return;

          lastUpdatedAtRef.current = updated_at;
          setUpdateInfo({ message, updated_at });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [systemKey]);

  const dismiss = () => setUpdateInfo(null);

  return { updateInfo, dismiss };
}
